import anastasiasAvif from './images/anastasias.true.avif';
import anastasiasJpg from './images/anastasias.true.jpg';
import anastasiasWebp from './images/anastasias.true.webp';
import arunachellanAvif from './images/arunachellan.avif';
import arunachellanJpg from './images/arunachellan.jpg';
import arunachellanWebp from './images/arunachellan.webp';
import brittWebp from './images/britt.venturesout.avif';
import brittJpg from './images/britt.venturesout.jpg';
import brittAvif from './images/britt.venturesout.webp';
import everydayadventurefamAvif from './images/everydayadventurefam.avif';
import everydayadventurefamJpg from './images/everydayadventurefam.jpg';
import everydayadventurefamWebp from './images/everydayadventurefam.webp';
import jadeteetselAvif from './images/jadeteetsel.avif';
import jadeteetselJpg from './images/jadeteetsel.jpg';
import jadeteetselWebp from './images/jadeteetsel.webp';
import kylamsteeleAvif from './images/kylamsteele.avif';
import kylamsteeleJpg from './images/kylamsteele.jpg';
import kylamsteeleWebp from './images/kylamsteele.webp';
import sabrina_obryanAvif from './images/sabrina_obryan.avif';
import sabrina_obryanJpg from './images/sabrina_obryan.jpg';
import sabrina_obryanWebp from './images/sabrina_obryan.webp';
import veganpattyyAvif from './images/veganpattyy.avif';
import veganpattyyJpg from './images/veganpattyy.jpg';
import veganpattyyWebp from './images/veganpattyy.webp';
import type { SocialCard } from './SocialCard';

// https://www.figma.com/file/4jQyetMgmp9fZfD5hN1He6/Denali%2B-Social%2BLifecycle-Components?type=design&node-id=4025-4970&mode=design&t=WJmbFZWWNRWgyRho-0

const CARDS: SocialCard[] = [
  { handle: '@everydayadventurefam', images: { jpg: everydayadventurefamJpg, webp: everydayadventurefamWebp, avif: everydayadventurefamAvif } },
  { handle: '@kylamsteele', images: { jpg: kylamsteeleJpg, webp: kylamsteeleWebp, avif: kylamsteeleAvif } },
  { handle: '@veganpattyy', images: { jpg: veganpattyyJpg, webp: veganpattyyWebp, avif: veganpattyyAvif } },
  { handle: '@anastasias.true', images: { jpg: anastasiasJpg, webp: anastasiasWebp, avif: anastasiasAvif } },
  { handle: '@arunachellan', images: { jpg: arunachellanJpg, webp: arunachellanWebp, avif: arunachellanAvif } },
  { handle: '@sabrina_obryan', images: { jpg: sabrina_obryanJpg, webp: sabrina_obryanWebp, avif: sabrina_obryanAvif } },
  { handle: '@britt.venturesout', images: { jpg: brittJpg, webp: brittWebp, avif: brittAvif } },
  { handle: '@jadeteetsel 1', images: { jpg: jadeteetselJpg, webp: jadeteetselWebp, avif: jadeteetselAvif } }
];

export default CARDS;
